import api from "../api";

export const saveDoctorAvailability = async (payload) => {
    const response = await api.post(
      "/PMSRoutes/SaveDoctorAvailability",
      payload
    );
  
    return response.data;
  };